import { useState, useLayoutEffect } from 'react';

export function useOverflow(ref) {
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    const element = ref?.current;
    if (!element) return;

    const check = () => {
      // Добавляем небольшой зазор в 1px для точности округления
      const hasOverflow = element.scrollWidth > element.clientWidth;
      setIsOverflowing(hasOverflow);
    };

    // ResizeObserver сработает, когда ширина контента изменится 
    // (например, добавились новые блоки в categories)
    const observer = new ResizeObserver(check);
    observer.observe(element);
    
    // Также следим за изменениями внутри (если ResizeObserver не поймал детей)
    const mutationObserver = new MutationObserver(check);
    mutationObserver.observe(element, { childList: true, subtree: true });

    check(); // Первая проверка

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, [ref]);

  return isOverflowing;
}
